import { settingsConstants } from '../constants';

export function GetSettings(state = {}, action) {
  switch (action.type) {
    case settingsConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case settingsConstants.GET_SUCCESS:
      return {
        ...state,
        items: action.items,
        loading: false
      }
    case settingsConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateSettings(state = {}, action) {
  switch (action.type) {
    case settingsConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case settingsConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case settingsConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}